export const allBlocks = [
  //
  require('./CoverSimple').default,
  require('./CoverImage').default,
  require('./CoverLeftText').default,
  require('./CoverRightText').default,
  require('./CoverText').default,
  require('./CoverImageLeft').default,
  require('./CoverImageRight').default,

  require('./CoverVideoLeft').default,
  require('./CoverVideoRight').default,

  require('./CoverImageSignup').default,
  require('./CoverVideoSignup').default,

  require('./BenefitImageLeft').default,
  // require('./BenefitImageRight').default,
  // require('./BenefitSmallImageLeft').default,
  // require('./BenefitSmallImageRight').default,
  // require('./BenefitImageCenter').default,
  //
  // require('./BenefitLargeImageLeft').default,
  // require('./BenefitLargeImageRight').default,
  // require('./BenefitLargeImageCenter').default,
  //
  // require('./BenefitImageOnlyGrid').default,
  //
  // require('./BenefitIconGrid3').default,
  // require('./BenefitIconGrid4').default,
  // require('./BenefitIconGrid5').default,
  // require('./BenefitIconGrid6').default,
  //
  // require('./BenefitVideoLeft').default,
  // require('./BenefitVideoRight').default,
  //
  // require('./ContactMapLeft').default,
  // require('./ContactMapRight').default,
  //
  // require('./TestimonialProfileLeft').default,
  // require('./TestimonialProfileRight').default,
  // require('./TestimonialAdjacentProfile3').default,
  // require('./TestimonialAdjacentProfile2').default,
  // require('./TestimonialAdjacent3').default,
  // require('./TestimonialAdjacent2').default,
  //
  // require('./SinglePlanPricing').default,
  // require('./PricingPlan3').default,
  //
  require('./ContactForm').default,
  require('./ContactFormLeft').default,
  require('./ContactFormRight').default,
  //
  // require('./CTA2Buttons').default,
  // require('./CTA3Buttons').default,

];



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/allBlocks.js